import React, { memo } from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';

import Total from './Total';

import TableDetails from './TableDetails';

const BORDER_COLOR = '#8A9EAF';
const BORDER_STYLE = 'solid';

const styles = StyleSheet.create({
  display__flex: {
    marginTop: 14,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row',
  },
  main__heading: {
    fontSize: 10,
    fontFamily: 'Roboto',
    fontWeight: '600',
  },
  mini__heading: {
    fontSize: 8,
    fontFamily: 'Roboto',
    fontWeight: '600',
  },
  mini__heading__inner: {
    fontSize: 8,
    fontFamily: 'Roboto',
    fontWeight: '400',
  },
  container__main: {
    marginTop: 10,
  },

  notes__main: {
    backgroundColor: 'rgba(231, 236, 244, .8)',
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    padding: 10,
    borderWidth: 0,
    borderLeftWidth: 1,
    borderTopWidth: 0,
    borderBottomWidth: 1,
    borderRightWidth: 1,
    borderTopLeftRadius: 0,
  },
  note__heading: {
    fontSize: 7,
    fontFamily: 'Roboto',
    fontWeight: '500',
    paddingBottom: 5,
  },
  note__text: {
    fontSize: 6,
    fontFamily: 'Roboto',
    fontWeight: '400',
  },
});

const Table = ({ data, currencySymbol }) => {
  const { jobs = [], addCommasToNumber, estimateTemplate = [] } = data || '';

  // making estimator according to estimator template
  const jobsInfo =
    estimateTemplate.find((temp) => temp.title?.toLowerCase() === 'jobs')
      ?.options || '';
  const jobTotals =
    estimateTemplate.find((temp) => temp.title?.toLowerCase() === 'job totals')
      ?.options || '';
  const showJobs = Object.values(jobsInfo ?? {})?.some((c) => c);

  return showJobs ? (
    <>
      {jobs?.map((job, i) => {
        console.log(';job', job);
        const { items = [] } = job?.extrasWithJob || '';
        const notes = job?.notes || '';
        return (
          <View style={styles.container__main}>
            <View style={styles.display__flex} key={i++}>
              <View>
                <Text style={styles.main__heading}>
                  {i + 1} of {jobs?.length} {job?.title ? '. ' + job.title : ''}
                </Text>
              </View>
            </View>
            <View>
              <TableDetails
                items={items}
                currencySymbol={currencySymbol}
                addCommasToNumber={addCommasToNumber}
                discountType={job.discountType}
                jobsInfo={jobsInfo}
              />
            </View>
            {/*  per job total */}
            <Total
              data={{ ...job } || ''}
              currencySymbol={currencySymbol}
              addCommasToNumber={addCommasToNumber}
              jobTotals={jobTotals}
            />
            <View style={styles.notes__main} wrap={false}>
              <Text style={styles.note__heading}>Notes:</Text>
              <Text style={styles.note__text}>{notes}</Text>
            </View>
          </View>
        );
      })}
    </>
  ) : (
    <View />
  );
};
export default memo(Table);
